export const signature = {
  editor: "Editer l’emplacment des signatures",
  aucun: "Aucun document chargé",
  desiner: "Veuillez dessiner votre signature.",
  entreText: "Veuillez entrer un texte.",
  importImge: "Veuillez importer une image.",
  succes: "Signature envoyée avec succès !",
  erreur: "Erreur lors de l’envoi.",
  raisonRefus: "Veuillez entrer une raison pour le refus.",
  erreurRefus: "Erreur lors de l’envoi du refus.",
  signDoc: "Signer le document",
  destinataire: "Destinataire",
  refus: "Refuser",
  rempliRefus: "Prière de remplir la raison du refus",
  envoieRefus: "Envoyer le refus",
  annuler: "Annuler",
  emailEnvoyee: "Les emails ont été envoyés avec succès !",
  emailErreur: "Erreur lors de l'envoi des emails.",
  enCours: "Envoi en cours...",
  envoyerDes: "Envoyer le lien aux destinataires ",
  emailSucces: "Envoyé avec succes",
  token: "Token manquant !",
  moinChamp: "Veuillez remplir au moins un champ.",
  erreurSignature: "Erreur lors de l'application des signatures",
  applique: "Signature appliquée",
  appliquer: "Appliquer la signature",
  choisirSign: "Choisir une signature",
  votreNom: "Entrer votre nom complet",
  import: "Importer une image",
  genererSign: "Générer une signature",
  nom: "Nom complet",
  check: "Appliquer ce préfixe à tous les champs prefix",
  valid: "Valider",
  generateur: "Générateur de signatures",
  entreNom: "Entrez votre nom",
  gener: "Générer",
  tousRempli: "Tous les champs doivent être remplis",
  orderValide: "Chaque destinataire doit avoir un ordre valide",
  orderUnique: "Chaque destinataire doit avoir un ordre unique",
  docNonCharge: "Document non chargé",
  destinataireSucces: "Destinataires enregistrés avec succès",
  errorEnreg: "Erreur lors de l'enregistrement",
  choixDes: "Choisir les destinataires",
  nom: "Nom",
  ajoutDes: "Ajouter un destinataire ",
  avecOrder: "Envoyer avec ordre",
  enregiestrer: "Enregistrer",
  emplSave: "Emplacements sauvegardés !",
  erreurSave: "Erreur lors de la sauvegarde",
  place: "Placer les champs dans le document",
  nomFichier: "Nom du fichier s’affiche ici",
  selectionne: "⚠️ Aucun fichier sélectionné.",
  pdfUnique: "⚠️ Veuillez sélectionner un fichier PDF uniquement.",
  aucunFichier: "⚠️ Aucun fichier sélectionné.",
  erreurUpload: "Erreur lors de l'upload",
  erruerEnvoi: "❌ Erreur d'envoi du fichier.",
  choixFichierPDF: "Choisir un fichier PDF",
  fichier: "Choisir un fichier",
};
